import React, { FC } from 'react';
import ManagementDropdown from 'src/dashboard/components/header/management-dropdown';
import DashboardSlideOvers from 'src/dashboard/components/slide-over';
import { PageSidebar } from '../sidebar';
import { useCurrentOrganization } from 'src/store/organization';
import classNames from 'classnames';

interface Props {
  sidebarEnabled?: boolean;
  renderSidebar?: JSX.Element;
}

export const PageLayout: FC<Props> = ({ sidebarEnabled = false, children }) => {
  const { currentOrganization } = useCurrentOrganization();

  return (
    <>
      <div className='relative w-full px-6'>
        <div className='flex mt-6'>
          <div
            className={classNames('flex flex-col self-start mr-10 sticky top-6 gap-6', {
              'z-20': !currentOrganization?.is_locked,
            })}
          >
            <div className='flex items-center-justify-betwen w-[12.5rem]'>
              <ManagementDropdown />
            </div>
            {sidebarEnabled && <PageSidebar />}
          </div>
          <main className='w-full self-start'>
            <div className='m-0 2k:mx-auto w-full max-w-page-content pb-lg mt-14'>{children}</div>
          </main>
        </div>
      </div>
      <DashboardSlideOvers />
    </>
  );
};
